import { useNavigate } from "react-router-dom";
import heroImg from "../assets/hero.png";

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="text-gray-600 body-font">
      <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
        <div
          className="
            lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 
            flex flex-col md:items-start md:text-left 
            mb-16 md:mb-0 items-center text-center
            opacity-0 animate-[fadeInUp_1s_ease-out_forwards]
          "
        >
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
            Makanan bergizi gratis.
            <br className="hidden lg:inline-block" />
            Investasi kecil untuk kesehatan.
          </h1>
          <h3 className="mb-8 text-xl leading-relaxed">
            Gizimon MBG adalah portal resmi Program Makanan Bergizi Gratis (MBG) Pemerintah Kota Depok,
            yang menyalurkan makanan sehat ke sekolah-sekolah guna mendukung tumbuh kembang dan prestasi siswa.
          </h3>
          <div className="flex justify-center">
            <button className="inline-flex text-white text--700 bg-gradient-to-r from-indigo-500 to-blue-500 border-0 py-2 px-6 focus:outline-none hover:opacity-90 rounded text-lg"
            onClick={() => navigate("/school")}>
              Telusuri Sekolah Penerima
            </button>
          </div>
        </div>
        <div
          className="
            lg:max-w-150% lg:w-150% md:w-1/2 w-5/6
            opacity-0 animate-[fadeInRight_1s_0.3s_ease-out_forwards]
          "
        >
          <img className="object-cover object-center rounded" alt="hero" src={heroImg} />
        </div>

      </div>
    </section>
  );
}
